module.exports = __webpack_public_path__ + "img/submit.7b5338fc.svg";